import { render } from "./InternetPurchase.vue?vue&type=template&id=62881806"
import script from "./InternetPurchase.vue?vue&type=script&lang=js"
export * from "./InternetPurchase.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "62881806"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('62881806', script)) {
    api.reload('62881806', script)
  }
  
  module.hot.accept("./InternetPurchase.vue?vue&type=template&id=62881806", () => {
    api.rerender('62881806', render)
  })

}

script.__file = "src/views/services/modules/internet/pills/InternetPurchase.vue"

export default script